import { useTranslation } from 'react-i18next';

const HOTJAR_BASE_URL = 'https://www.hotjar.com';

export const useHotjarUrl = (): ((slug?: string) => string) => {
  const { i18n } = useTranslation();

  const currentLanguage = i18n?.resolvedLanguage ?? 'en';

  return (slug) =>
    `${HOTJAR_BASE_URL}/${currentLanguage === 'en' ? 'en-US' : currentLanguage}${
      slug !== undefined ? slug : ''
    }`;
};
